import { ProviderAccount } from '@prisma/client'
import React from 'react'
import { DataConnectorClient } from '~/plugins/data-connector/client'

type Props = {
  id?: string
  value?: string
  initialValues?: string
  providerKey?: string
  scopes?: string[]
  onChange?: (value: string) => void
}

export const SelectProviderAccount: React.FC<Props> = ({
  id,
  value,
  initialValues,
  providerKey,
  scopes,
  onChange,
}) => {
  const { providerClient: provider } = DataConnectorClient.useProvider({
    providerKey,
  })

  const handleChange = (providerAccount: ProviderAccount) => {
    onChange?.(providerAccount.id)
  }

  const handleClear = () => {
    onChange?.(null)
  }

  return (
    <span id={id}>
      <DataConnectorClient.SelectAccount
        provider={provider}
        providerAccountId={value}
        scopes={scopes}
        onChange={handleChange}
        onClear={handleClear}
      />
    </span>
  )
}
